export default __webpack_public_path__ + "static/media/CO2.358ec33e.svg";